export default __webpack_public_path__ + "static/media/4_Lista_mob.6a72cf30.webp";